// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The status
 */
export type CorpoResponseStatus = 'success' | 'not_ready' | 'error';

export const CorpoResponseStatus = {
    success: 'success' as CorpoResponseStatus,
    not_ready: 'not_ready' as CorpoResponseStatus,
    error: 'error' as CorpoResponseStatus
};

